export const COMMON_SELECTED_TEXT = "common.selected";
export const COMMON_ADD_TEXT = "common.add";
